import { useCallback, useState } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { IconButton, Stack } from '@mui/material';

import { FDropzone } from '../../../../../../components/base';
import { Themes } from '../../../../../../constants';
import {
  ASSESSMENT_METHOD_VISUAL_ACCEPT,
  ASSESSMENT_METHOD_VISUAL_FILE_NAME_PATTERN,
  ASSESSMENT_METHOD_VISUAL_MAX_SIZE_MB,
} from '../constants';

import type { AssessmentMethodVisualCardActionsProps } from './types';

export default function AssessmentMethodVisualCardActions({
  disabled,
  isSaving,
  onDelete,
  onSelectFile,
}: AssessmentMethodVisualCardActionsProps) {
  const [isFileDropzoneOpen, setIsFileDropzoneOpen] = useState(false);
  const handleOpenFileDropzone = useCallback(() => setIsFileDropzoneOpen(true), []);
  const handleCloseFileDropzone = useCallback(() => setIsFileDropzoneOpen(false), []);
  const handleSelectReplacementFile = useCallback(
    (files: File[]) => {
      const file = files[0];
      if (!file) return;
      setIsFileDropzoneOpen(false);
      void onSelectFile(file);
    },
    [onSelectFile],
  );

  return (
    <>
      <Stack direction="row" justifyContent="flex-end">
        <IconButton
          aria-label="Change visual file"
          disabled={disabled || isSaving}
          onClick={handleOpenFileDropzone}
        >
          <EditOutlinedIcon />
        </IconButton>
        <IconButton
          aria-label="Delete visual"
          disabled={disabled || isSaving}
          onClick={onDelete}
        >
          <DeleteOutlineIcon />
        </IconButton>
      </Stack>

      <FDropzone
        accept={ASSESSMENT_METHOD_VISUAL_ACCEPT}
        colorTheme={Themes.Primary}
        fileNameRegEx={ASSESSMENT_METHOD_VISUAL_FILE_NAME_PATTERN}
        maxSize={ASSESSMENT_METHOD_VISUAL_MAX_SIZE_MB}
        onClose={handleCloseFileDropzone}
        onSelect={handleSelectReplacementFile}
        show={isFileDropzoneOpen}
        submitText="Save visual"
        title="Update visual"
      />
    </>
  );
}
